export const DAY_TRANSFER_POST = '/day_transfer/';
